export default __webpack_public_path__ + "static/press-release-itb2020-a225301f68801d95b6ac858c9d6a0fd8.png";